// eslint-disable-next-line react/display-name
export default () => (
  <svg
    version="1.1"
    viewBox="0 0 80.404 132.29"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="matrix(1.0263 0 0 1.0263 -277.15 -219.38)">
      <g transform="matrix(.47528 0 0 -.47528 -921.84 522.15)">
        <g transform="matrix(1.1732,0,0,1.1732,2616.2,480.36)">
          <path
            id="path-B"
            d="m0 0c-3.243-3.335-7.566-4.999-12.971-4.999h-36.208v36.208h36.208c5.405 0 9.728-1.668 12.971-4.999 3.242-3.335 4.863-7.701 4.863-13.105s-1.621-9.773-4.863-13.105m-49.179 103.08h30.804c4.864 0 8.824-1.579 11.89-4.728 3.06-3.154 4.592-7.161 4.592-12.024 0-4.864-1.532-8.875-4.592-12.025-3.066-3.154-7.026-4.728-11.89-4.728h-30.804zm74.039-50.529c0 1e-3 0 1e-3 -1e-3 3e-3 10.986 9.545 16.482 21.885 16.482 37.016 0 16.031-5.721 29.047-17.158 39.045-11.441 9.997-25.626 14.996-42.558 14.996h-68.831c-2.875 0-5.205-2.33-5.205-5.205v-183.94h0.014c-8e-3 0-0.014-7e-3 -0.014-0.014v-30.276c0-10.751 13.265-15.83 20.444-7.827l34.175 38.093c8e-3 9e-3 2e-3 0.023-0.011 0.023l-1e-3 1e-3h24.833c17.293 0 31.792 5.133 43.504 15.402 11.707 10.268 17.564 23.596 17.564 39.989 0 18.551-7.747 32.783-23.237 42.692"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </svg>
);
